import t from "../../../helpers/t";
import {$, _, moment} from "../../../../../vendor";
import React, {useEffect, useState} from "react";
import {reservationsActions, useSelector} from "inbooma-api";
import {Biscuit, FormatHelper} from "../../../../utils";
import InboomaBaseView from "../../../../views/InboomaBaseView";
import {CheckinsProgressBar} from "./CheckinsProgressBar";
import Checkins from "./Checkins";

const OrderReservations = (props) => {
    const [locations] = useState(props.locations);
    const [ready,setReady] = useState(false);
    const[isBikeSharing,setIsBikeSharing] = useState(false);
    const _patchReservation = useSelector(state => state.reservations.patchReservations);
    const [reservationsPending,setReservationsPending] = useState(null);
    useEffect(() => {
        if (!reservationsPending || _patchReservation.success === "") {
            return;
        }

        if (_patchReservation.success === true) {
            props.order.reservations[reservationsPending].status=_patchReservation.data.status;
            props.showNotification('success',_patchReservation.data.id,'','reservation');
        } else {
            props.showNotification('warning',null,(typeof _patchReservation.data.message !== 'undefined'?_patchReservation.data.message:t('could_not_be_saved_${a}',{a:t('reservation')},'capital')));
            console.log("Failed patching reservation!");
        }
        setReservationsPending(null);
        // props.filterChangedHandle(props.filter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_patchReservation]);

    const _showPopUp = () => {
        let output = "<html><head>"+
            '<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">'+
                "<title>"+t('form_data')+"</title>"+
                '<style type="text/css">'+
                    'body { font-family: "Open Sans",Helvetica,Arial,sans-serif; } '+
                    "hode, html, table, thead { width: 100%; } "+
                    "h4 { font-size: 18px; } "+
                    ".printSpacer { height:100px; } "+
                "</style> </head><div>"+props.order.form_data +`</body>
            </html>`;
        let rV = -1; // Return value assumes failure.

        if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {

            var uA = navigator.userAgent;
            // eslint-disable-next-line no-useless-escape
            var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

            if (rE.exec(uA) != null) {
                rV = parseFloat(RegExp.$1);
            }
            // eslint-disable-next-line no-useless-escape, no-extra-boolean-cast
            else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                rV = 11;
            }
        }

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const newWindow = window.open('', '', 'height=700,width=674');

        newWindow.document.body.innerHTML = '';
        newWindow.document.body.innerHTML = output;
        if (rV >=10 || isChrome) {
            newWindow.focus(); // necessary for IE >= 10*
        } else {
            // e.g. Firefox
            setTimeout(() => {
                newWindow.opener.focus();
            }, 0);
        }
        return true;
    }
    var attr = $('#row-'+props.order.id).attr('toggled');

    let toggled = typeof attr !== 'undefined' && attr !== false;
    let hasCheckins = false,
        hasCompletedCheckouts = false,
        hasFutureCheckout = false,
        hasFutureCheckin = false;
   /* useEffect(() => {

        if (_order.success === "") return;

        if (_order.success === true) {
            setOrder(_order.data);
            let hasReservations = (typeof _order.data.reservations !== 'undefined' && typeof _order.data.reservations !== 'undefined');
            let description = ''; // Unset order description #18917

            if (hasReservations) {

                if (typeof _order.data.reservations[0] !== 'undefined') {
                    if (typeof _order.data.reservations[0].contingents[0] !== 'undefined') {
                        if (typeof _order.data.reservations[0].checkins !== 'undefined' && _order.data.reservations[0].checkins.length >= 1) {
                            setIsBikeSharing(true);
                            if (typeof _order.data.reservations[0].checkins[0] !== 'undefined') {

                                let cont = _order.data.reservations[0].contingents[0];

                                if (_order.data.reservations[0].checkins[0].resource !== null
                                    && _order.data.reservations[0].checkins[0].resource !== 'null') {
                                    // At this level we used to state that booking came from app.
                                    // This is not always true anymore.
                                    //    description = t('app_order_bike_tour_${a}',{a:reservations.models[0].get('contingents')[0].name});
                                } else {

                                    if (cont.deleted !== null && cont.deleted !== '') {
                                        description = t('app_order_bike_tour_min_${a}',{a: cont.name + ', ' + t('contingent_removed')});
                                    } else {
                                        description = t('app_order_bike_tour_${a}',{a:t('deleted_resource')}); // OR: Selection of resource in app has not yet been done
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else if (_order.success === false) {
            console.log("Failed to request order!");
        }
        setOrderPending(false);
        if(!locationsPending) {
            setReady(true);
        }

    },[_order]);*/



    const initialize = () => {
        if (ready) {
            return;
        }
       // console.log(order);
       /* if (orderPending) {
            return;
        }*/

       /* props.dispatch(ordersActions.getOrder({
            token: Biscuit.get('token'),
            id: props.order_id,
            filter: {
                find: 'full'
            },
        }));
        setOrderPending(true);
*/
        let hasReservations = (typeof props.order.reservations !== 'undefined' && typeof props.order.reservations.length);
        //let description = ''; // Unset order description #18917

        if (hasReservations) {

            if (typeof props.order.reservations[0] !== 'undefined') {
                if (typeof props.order.reservations[0].contingents[0] !== 'undefined') {
                    if (typeof props.order.reservations[0].checkins !== 'undefined' && props.order.reservations[0].checkins.length >= 1) {
                        setIsBikeSharing(true);
                        if (typeof props.order.reservations[0].checkins[0] !== 'undefined') {

                            //let cont = props.order.reservations[0].contingents[0];

                            if (props.order.reservations[0].checkins[0].resource !== null
                                && props.order.reservations[0].checkins[0].resource !== 'null') {
                                // At this level we used to state that booking came from app.
                                // This is not always true anymore.
                                //    description = t('app_order_bike_tour_${a}',{a:reservations.models[0].get('contingents')[0].name});
                            } else {
                               /* let description;
                                if (cont.deleted !== null && cont.deleted !== '') {
                                    description = t('app_order_bike_tour_min_${a}',{a: cont.name + ', ' + t('contingent_removed')});
                                } else {
                                    description = t('app_order_bike_tour_${a}',{a:t('deleted_resource')}); // OR: Selection of resource in app has not yet been done
                                }*/
                            }
                        }
                    }
                }
            }
        }
        setReady(true);
    };


    if (!ready) {
        initialize();
    }

    const showCheckout = (reservation,checkin) => {
        props.setCheckoutReservation(reservation);
        props.setCheckoutCheckin(checkin);
        props.setFilter(props.filter);
        props.setSort(props.sort);
        props.setNKey(props._key);
        props.setCheckout(true);
    }

    const printContingentsAmountList = (memo,reservation, type='reservation') => {

        let r = ' ';
        if(type==='order'){
            let amountPerContingent = {};

            if(typeof props.order.reservations !== 'undefined' && props.order.reservations.length >= 1) {

                _.each(props.order.reservations,function(reservation) {
                    if (typeof reservation.contingents_reservations !== 'undefined' && reservation.contingents_reservations.length >= 1) {
                        // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
                        // however reservation.contingents has the contingent information)

                        _.each(reservation.contingents_reservations, function (contingent) {
                            // Get amount per contingent
                            if (typeof amountPerContingent[contingent.contingent_id] === 'undefined') {
                                amountPerContingent[contingent.contingent_id] = contingent.amount;
                            } else {
                                amountPerContingent[contingent.contingent_id] += contingent.amount;
                            }
                        });

                        _.each(amountPerContingent, function (amount, contingent_id) {
                            // Get contingent data from contingents array

                            let full_contingent = _.filter(reservation.contingents, function (contingent) {
                                return Number(contingent.id) === Number(contingent_id);
                            })[0];
                            if (typeof full_contingent !== 'undefined') {

                                let contingentDeleted = '';

                                if (typeof full_contingent.deleted !== 'undefined'
                                    && full_contingent.deleted !== null
                                    && full_contingent.deleted !== '') {
                                    contingentDeleted = ' (' + InboomaBaseView.prototype.t('removed_${a}', {a: InboomaBaseView.prototype.t('contingent')}) + ')';
                                    reservation._has_any_deleted_item;
                                }

                                const size = FormatHelper.formatContingentTags(full_contingent.tags);

                                r += (r !== ' ' || memo !== '' ? ', ' : '') + full_contingent.name + size + contingentDeleted + ' x ' + amount;

                            }

                        });
                    } else {

                        // Regular (e.g. not-client-7) reservation
                        _.each(reservation.contingents, function (contingent) {
                            if (typeof contingent._joinData === 'undefined') return;
                            r += (r !== ' ' || memo !== '' ? ', ' : '') + contingent.name + ' x ' + contingent._joinData.amount;
                        });
                    }
                });
            }else {

                // Regular (e.g. not-client-7) reservation
                _.each(reservation.contingents, function (contingent) {
                    if (typeof contingent._joinData === 'undefined') return;
                    r += (r !== ' ' || memo !== '' ? ', ' : '') + contingent.name + ' x ' + contingent._joinData.amount;
                });
            }
        } else {


            // Fallback: Reservation was just created in this session so contingent._joinData is missing,
            // receive it from summedContingents
            _.each(typeof reservation.summedContingents !== 'undefined' && reservation.summedContingents, function (contingents) {

                if (typeof contingents.models[0] != 'undefined') {
                    let size = FormatHelper.formatContingentTags(contingents.models[0].get('tags'));
                    r = r + ((memo !== '' || r !== ' ') ? ', ' : '') + `${contingents.models[0].get('name')}${size} x ${contingents.length}`;
                }
            });

            if (r !== null && r !== ' ') {
                return memo + r;
            }

            if (!reservation?.contingents?.length) {
                return memo;
            }

            let amountPerContingent = {};

            if (typeof reservation?.contingents_reservations !== 'undefined' && reservation?.contingents_reservations.length >= 1) {
                // Client-7 reservations (where reservation.contingents_reservations holds the acutal amount,
                // however reservation.contingents has the contingent information)

                _.each(reservation?.contingents_reservations, function (contingent) {
                    // Get amount per contingent
                    if (typeof amountPerContingent[contingent.contingent_id] === 'undefined') {
                        amountPerContingent[contingent.contingent_id] = contingent.amount;
                    } else {
                        amountPerContingent[contingent.contingent_id] += contingent.amount;
                    }
                });

                _.each(amountPerContingent, function (amount, contingent_id) {
                    // Get contingent data from contingents array

                    let full_contingent = _.filter(reservation.contingents, function (contingent) {
                        return Number(contingent.id) === Number(contingent_id);
                    })[0];
                    if (typeof full_contingent !== 'undefined') {

                        let contingentDeleted = '';

                        if (typeof full_contingent.deleted !== 'undefined'
                            && full_contingent.deleted !== null
                            && full_contingent.deleted !== '') {
                            contingentDeleted = ' (' + InboomaBaseView.prototype.t('removed_${a}', {a: InboomaBaseView.prototype.t('contingent')}) + ')';
                            reservation._has_any_deleted_item;
                        }

                        const size = FormatHelper.formatContingentTags(full_contingent.tags);

                        r += (r !== ' ' || memo !== '' ? ', ' : '') + full_contingent.name + size + contingentDeleted + ' x ' + amount;

                    }

                });
            } else {

                // Regular (e.g. not-client-7) reservation
                _.each(reservation?.contingents, function (contingent) {
                    if (typeof contingent._joinData === 'undefined') return;
                    r += (r !== ' ' || memo !== '' ? ', ' : '') + contingent.name + ' x ' + contingent._joinData.amount;
                });
            }
        }
        return memo + r;
    }
    const setStatus = (e,reservation,index) => {
        props.dispatch(reservationsActions.patchReservations({
            token: Biscuit.get('token'),
            reservation_id: reservation.id,
            data: {
                status: e.target.value
            }
        }));
        setReservationsPending(index);
    }

    const getStatus = (reservation) => {
        let status = reservation.status;
        let stati = [
            {text: t('requested',null,'capital'), value: 'requested', disabled: "", selected: (status==='requested')},
            {text: t('confirmed',null,'capital'), value: 'confirmed', disabled: "", selected: (status==='confirmed')},
            {text: t('authorized',null,'capital'), value: 'authorized', disabled: "disabled", selected: (status==='authorized')},
            {text: t('payment_pending',null,'capital'), value: 'pending', disabled: "", selected: (status==='pending')}
        ];
        if (status === 'booking_process' || status === 'inprogress' || status === 'completed') {
            if (status === 'booking_process' || status === 'inprogress') {
                stati.push({
                    text: t(props._exchangeLabel('inprogress'), null, 'capital'),
                    value: 'inprogress',
                    disabled: "",
                    selected: (status === 'booking_process' || status === 'inprogress')
                })
            }
        }
        stati.push({text: t('completed',null,'capital'), value: 'completed', disabled: "", selected: (status==='completed')})
        stati.push({text: t('paid',null,'capital'), value: 'paid', disabled: "", selected: (status==='paid')})
        stati.push({text: t('cancelled',null,'capital'), value: 'cancelled', disabled: "", selected: (status==='cancelled')})
        return stati;
    }

    return (
        <>
            {props.order !== null && <><div id={"reservation-panel-"+props.order.id} className="inb-c-item-details inb-c-order-reservations row">

                {(!isBikeSharing) &&
                <>
                    <header className="inb-c-item-details__header small-12 column">
                        <a href={"/orders/" + props.order.id + "/add"}
                           className="inb-c-item-add inb-reservation__add small button beautify float-right"
                           data-inb-action-link="write">
                            {t('add_${a}', {a: t('reservation')})}
                        </a>
                        {props.order.form_data !== null && props.order.form_data !== '' &&
                        <>
                                    <span style={{marginRight: "5px", padding: "0.85em 1em", marginTop: "0px"}}
                                          className="inb-c-item-show-form-data trigger_popup_form_data small button beautify float-right"
                                          id={"fd_" + props.order.id} onClick={e=>_showPopUp(e)}>
                                        {t('show form data')}
                                    </span>
                        </>
                        }
                        {typeof props.order.reservations === 'undefined' || props.order.reservations.length === 0 &&
                        <>
                                <span className="inb-list-title">
                                    {t('no_linked_reservations')}
                                </span>
                        </>
                        }
                        {typeof props.order.reservations !== 'undefined' && props.order.reservations.length > 0 &&
                        <>
                                <span className="inb-list-title">
                                     {t('linked_reservations') + " (" + props.order.reservations.length + ")"}
                                </span>
                        </>
                        }
                        <span className="off-canvas__form-error fi fi-alert hide">
                                {t('order_not_confirmed_warning')}
                            </span>
                    </header>

                    {typeof props.order.reservations !== 'undefined' && props.order.reservations.length > 0 && props.order.reservations.map((reservation,index) => {
                        if (reservation.id === null || reservation.id === "") {
                            return (<></>);
                        }
                        var is_appointment = (reservation?.contingents?.length > 0 && reservation?.contingents[0].resourcetype_id === 4);
                        var begin = moment(reservation.begin);
                        var end = moment(reservation.end);
                        var hasEnded = (typeof reservation.checkins !== 'undefined' && typeof reservation.checkins[0] !== 'undefined' && typeof reservation.checkins[0].checkout !== 'undefined' || end.format('X') < moment().format('X'));
                        var begin_location_id = (reservation.location_id === null ? reservation.begin_location : reservation.location_id);
                        var end_location_id = (reservation.end_location === null ? null : reservation.end_location);
                        if (begin_location_id !== null) {
                            var _begin_location = locations[begin_location_id];
                        }
                        var end_location_text = "";
                        var begin_location_text = "";
                        var description_text = "";
                        if (end_location_id !== null) {
                            var _end_location = locations[end_location_id];
                        }
                        if (typeof _end_location !== 'undefined') {
                            end_location_text = ' -- ' + t('location_of_checkout') + ': ' + _end_location.name + ')';
                            if (typeof _end_location.deleted !== 'undefined' && _end_location.deleted !== null && _end_location.deleted !== '') {
                                end_location_text += ' (' + t('removed_${a}', {a: t('location')}) + ')';
                                reservation._has_any_deleted_item = true;
                            }
                        }
                        if (typeof _begin_location !== 'undefined') {
                            begin_location_text = "( " + t('location_of_checkin') + ": " + _begin_location.name;
                            if (typeof _begin_location.deleted !== 'undefined'
                                && _begin_location.deleted !== null
                                && _begin_location.deleted !== '') {

                                reservation.set('_has_any_deleted_item', true);
                                begin_location_text += ' (' + t('removed_${a}', {a: t('location')}) + ')';
                            }
                        } else {
                            begin_location_text = "(" + t('removed_${a}', {a: t('location')}) + ")";
                        }

                        if (reservation.description !== null && reservation.description !== '' && reservation.description !== ' ') {
                            description_text = "| " + reservation.description
                        }

                        if (!reservation?.contingents?.length) {
                            reservation.contingents = [];
                            reservation.contingents.push({name: '(' + t('contingent_removed') + ')'});
                        }
                        return (
                            <>
                                <div className="inb-reservation inb-c-item-details-row row"
                                     data-inb-reservation={reservation.id} data-inb-context="reservations">
                                    <div className="medium-8 small-12 column">
                                        {printContingentsAmountList('',reservation)+ " "}
                                        {!is_appointment &&
                                        <>
                                            {begin_location_text}
                                            {end_location_text}
                                            {description_text}
                                            | <span className="inb-reservation__begin"
                                                    title={begin.format('MMMM Do YYYY, h:mm:ss a')}>
                                                        {begin.format('dd, DD.MM.YY, HH:mm')}
                                                  </span> -
                                            <span className="inb-reservation__end"
                                                  title={end.format('MMMM Do YYYY, h:mm:ss a')}>
                                                            {end.format('dd, DD.MM.YY, HH:mm')}
                                                  </span>
                                        </>
                                        }
                                    </div>

                                    <div className="medium-2 small-5 column"
                                         title={hasEnded ? t('reservation_ended_not_editable') : ''}>
                                        <div className={"inb-status-select inb-before-badge"+(toggled?'':' hide')}
                                             data-inb-status={reservation.status}>
                                            {reservationsPending !== index  ? <>
                                                    <select className="inb-status-select" disabled={Biscuit.get('user.role') === 'user'?'disabled':''}
                                                            data-inb-action-link="edit-status" onChange={(e)=>setStatus(e,reservation,index)} defaultValue={reservation.status}>


                                                    {getStatus(reservation).map((obj) => {
                                                            return (<>
                                                                    <option value={obj.value} disabled={obj.disabled}>{obj.text}</option>
                                                                </>
                                                            )
                                                        })}
                                                    </select></>:<> <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"assets/img/rolling_loader.svg"} /> </span>
                                            </>}
                                            <select className="inb-status-select" disabled={Biscuit.get('user.role') === 'user'?'disabled':''}
                                                    data-inb-action-link="edit-status" onChange={()=>setStatus(reservation,index)}>

                                            </select>
                                        </div>
                                    </div>

                                    <div className="medium-2 small-7 column text-right"
                                         style={{paddingLeft: "0", paddingRight: "0"}}>
                                        {reservation.status !== 'cancelled' &&
                                        <>
                                            <a href={"#"}
                                               onClick={() => showCheckout(reservation,reservation.checkins[0])}
                                               title={(typeof reservation.checkins === 'undefined' || reservation.checkins.length === 0 ? t('checkin_reservation', null, 'capital') : t('checkout_reservation', null, 'capital'))}
                                               data-inb-action-link="edit">
                                                <button type="button"
                                                        className="inb-round-btn hollow round float-right"
                                                        style={{marginLeft: "10px"}}>
                                                    <div className="inb-accordion-icon inb-fi-checkin"> </div>
                                                </button>
                                            </a>
                                        </>
                                        }
                                        {typeof reservation._has_any_deleted_item === 'undefined' &&
                                        <>
                                            <a className="inb-reservation__edit"
                                               href={"/orders/" + props.order.id + "/edit/" + reservation.id}
                                               title={t('order_edit')} data-inb-action-link="edit">
                                                <button type="button"
                                                        className="inb-round-btn hollow round float-right">
                                                    <div className="inb-accordion-icon inb-fi-edit"> </div>
                                                </button>
                                            </a>
                                        </>
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    })
                    }
                </>
                }
                {isBikeSharing &&
                <>
                    {typeof props.order.reservations !== 'undefined' && props.order.reservations.length && props.order.reservations.map(reservation => {
                        let data = {
                            app_user_role: props.app_user_role,
                            dispatch: props.dispatch,
                            checkout: props.checkout,
                            setCheckout: props.setCheckout,
                            setCheckoutReservation: props.setCheckoutReservation,
                            setCheckoutCheckin: props.setCheckoutCheckin,
                            locations: locations,
                            setFilter: props.setFilter,
                            filter: props.filter,
                            setNKey: props.setNKey,
                            sort: props.sort,
                            setSort: props.setSort,
                            _key: props._key
                        };
                        if(typeof reservation.checkins === 'undefined' || !reservation.checkins.length){
                            return(<> </>);
                        }
                        hasCheckins=true;
                        hasCompletedCheckouts = _.every(reservation.checkins, function (checkin) {
                            return typeof checkin.checkout !== 'undefined' && checkin.checkout !== null
                        });
                        hasFutureCheckout = _.every(reservation.checkins, function (checkin) {
                            return typeof checkin.checkout !== 'undefined' && checkin.checkout !== null && moment(checkin.checkout) > moment(new Date());
                        });
                        hasFutureCheckin= _.every(reservation.checkins, function (checkin) {
                            return typeof checkin.checkin !== 'undefined' && moment(checkin.checkin) > moment(new Date());
                        });
                        return (
                            <>
                                <Checkins
                                    data={data}
                                    reservation={reservation}
                                    panel={false}
                                />
                            </>
                        );
                    })}
                </>
                }

            </div>
            {hasCheckins &&
            <>
                <CheckinsProgressBar
                    hasCompletedCheckouts={hasCompletedCheckouts}
                    hasFutureCheckout={hasFutureCheckout}
                    hasFutureCheckin={hasFutureCheckin}
                    _exchangeLabel={props._exchangeLabel}
                    />
            </>
            }

            </>}
                </>
    )
}

export default OrderReservations;